import React from "react";
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Chip,
  FormHelperText,
} from "@mui/material";

const GeneralInfoSection = ({
  formData,
  setFormData,
  sizeOptions,
  formErrors,
}) => {
  return (
    <Box>
      <TextField
        label="Internal Name"
        fullWidth
        value={formData.name}
        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        sx={{ mb: 2 }}
        error={!!formErrors.name}
        helperText={formErrors.name}
      />

      <TextField
        label="Display Name"
        fullWidth
        value={formData.displayName}
        onChange={(e) =>
          setFormData({ ...formData, displayName: e.target.value })
        }
        sx={{ mb: 2 }}
        error={!!formErrors.displayName}
        helperText={formErrors.displayName}
      />

      <TextField
        label="Description"
        fullWidth
        multiline
        rows={3}
        value={formData.description}
        onChange={(e) =>
          setFormData({ ...formData, description: e.target.value })
        }
        sx={{ mb: 2 }}
        error={!!formErrors.description}
        helperText={formErrors.description}
      />

      <TextField
        label="Searchable Description"
        fullWidth
        value={formData.searchableDescription}
        onChange={(e) =>
          setFormData({
            ...formData,
            searchableDescription: e.target.value,
          })
        }
        sx={{ mb: 2 }}
      />

      <TextField
        label="Flavor"
        fullWidth
        value={formData.flavor}
        onChange={(e) => setFormData({ ...formData, flavor: e.target.value })}
        sx={{ mb: 2 }}
        error={!!formErrors.flavor}
        helperText={formErrors.flavor}
      />

      <FormControl fullWidth sx={{ mb: 2 }} error={!!formErrors.sizes}>
        <InputLabel>Size</InputLabel>
        <Select
          multiple
          value={formData.sizes}
          onChange={(e) => setFormData({ ...formData, sizes: e.target.value })}
          renderValue={(selected) => (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {selected.map((sizeId) => {
                const size = sizeOptions.find((s) => s._id === sizeId);
                return size ? (
                  <Chip key={sizeId} label={`${size.name} ($${size.price})`} />
                ) : null;
              })}
            </Box>
          )}>
          {sizeOptions.map((size) => (
            <MenuItem key={size._id} value={size._id}>
              {size.name} (${size.price})
            </MenuItem>
          ))}
        </Select>
        {formErrors.sizes && (
          <FormHelperText>{formErrors.sizes}</FormHelperText>
        )}
      </FormControl>

      <FormControl fullWidth sx={{ mb: 2 }} error={!!formErrors.style}>
        <InputLabel>Style</InputLabel>
        <Select
          value={formData.style}
          onChange={(e) => setFormData({ ...formData, style: e.target.value })}>
          <MenuItem value="bake">Baked</MenuItem>
          <MenuItem value="no-bake">No-Bake</MenuItem>
        </Select>
        {formErrors.style && (
          <FormHelperText>{formErrors.style}</FormHelperText>
        )}
      </FormControl>
    </Box>
  );
};

export default GeneralInfoSection;
